import Button from '../../../../components/Button/Button';
import HookForm from '../../../../components/HookForm/HookForm';
import LoaderInline from '../../../../components/Loader/LoaderInline';

const Reregistration = ({ onSubmit, loading }) => {
  if (loading) {
    return <LoaderInline />;
  }
  return (
    <>
      {/* <HookForm
        title={'ÐÐµÑÐµÐ¾ÑÐ¾ÑÐ¼Ð»ÐµÐ½Ð¸Ðµ Ð¢Ð¡'}
        grid={{ display: 'grid', gap: 20 }}
        action={'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ Ð¸ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ'}
        inputs={[
          {
            label: 'VIN ÐºÐ¾Ð´',
            name: 'reg_num',
            required: true,
          },
        ]}
        onSubmit={onSubmit}
        loading={loading}
      /> */}
      <Button text="ÐÐ¾Ð´ÑÐ²ÐµÑÐ´Ð¸ÑÑ Ð¿ÐµÑÐµÐ¾ÑÐ¾ÑÐ¼Ð»ÐµÐ½Ð¸Ðµ Ð¢Ð¡" onClick={onSubmit} />
    </>
  );
};

export default Reregistration;
